import { Link } from 'react-router-dom';
import { categories } from '@/mocks/products';

const productCounts: Record<string, number> = {
  Footwear: 48,
  Jackets: 36,
  Tents: 24,
  Backpacks: 52,
  Climbing: 30,
  Navigation: 18,
};

export default function CategoryShowcase() {
  return (
    <section id="categories" className="py-20 md:py-28 bg-white">
      <div className="px-6 md:px-12">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <p className="font-outfit text-xs uppercase tracking-[0.2em] text-gray-400 mb-2">Shop by Activity</p>
            <h2 className="font-outfit font-black text-[#1A1A1A] text-4xl md:text-5xl leading-none">
              Find Your<br />
              <em className="not-italic text-[#1A1A1A]/40">Adventure</em>
            </h2>
          </div>
          <p className="font-inter text-sm text-gray-500 max-w-xs">
            Browse our curated collections built for every discipline — from desert ultramarathons to Himalayan expeditions.
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Large Left Card */}
          <div className="md:row-span-2">
            <Link
              to="/products"
              className="block relative h-64 md:h-full rounded-2xl overflow-hidden group cursor-pointer"
              style={{ minHeight: '420px' }}
            >
              <img
                src={categories[0].image}
                alt={categories[0].name}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="inline-flex items-center gap-2 bg-black/50 backdrop-blur-sm rounded-lg px-3 py-2">
                  <p className="font-outfit font-bold text-white text-lg">{categories[0].name}</p>
                  <span className="text-white/50 font-inter text-xs">{productCounts[categories[0].name]} items</span>
                </div>
              </div>
            </Link>
          </div>

          {/* Right Column - Stacked */}
          {categories.slice(1, 3).map((cat) => (
            <Link
              key={cat.name}
              to="/products"
              className="block relative h-52 rounded-2xl overflow-hidden group cursor-pointer"
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="inline-flex items-center gap-2 bg-black/50 backdrop-blur-sm rounded-lg px-3 py-2">
                  <p className="font-outfit font-bold text-white">{cat.name}</p>
                  <span className="text-white/50 font-inter text-xs">{productCounts[cat.name]} items</span>
                </div>
              </div>
            </Link>
          ))}

          {/* Bottom Row */}
          {categories.slice(3).map((cat) => (
            <Link
              key={cat.name}
              to="/products"
              className="block relative h-52 rounded-2xl overflow-hidden group cursor-pointer"
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="inline-flex items-center gap-2 bg-black/50 backdrop-blur-sm rounded-lg px-3 py-2">
                  <p className="font-outfit font-bold text-white">{cat.name}</p>
                  <span className="text-white/50 font-inter text-xs">{productCounts[cat.name]} items</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
